import { UserSearchBox } from '@/components/home/user-search-box';
import { AlertsCard } from '@/features/compliance-alerts/alerts-card';
import { useAuthStore } from '@/lib/auth/store';
import { formatGreetingTimestamp } from '@/utils/format';
import { firstNameFrom } from '@/utils/string';

const MORNING_END_HOUR = 12;
const AFTERNOON_END_HOUR = 18;
const EVENING_START_HOUR = 5;

const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour >= EVENING_START_HOUR && hour < MORNING_END_HOUR) return 'Good morning';
  if (hour >= MORNING_END_HOUR && hour < AFTERNOON_END_HOUR) return 'Good afternoon';
  return 'Good evening';
};

const HomePage = () => {
  const user = useAuthStore((state) => state.user);
  // `name` is an email on accounts with no display name set, so it needs deriving rather than splitting
  const firstName = user ? firstNameFrom(user.name) : '';

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
        <h1 className="min-w-0 break-words text-2xl font-semibold sm:text-3xl">
          {getGreeting()}
          {firstName ? (
            <>
              , <strong>{firstName}</strong>
            </>
          ) : null}
        </h1>
        <span className="text-sm text-muted-foreground">{formatGreetingTimestamp()}</span>
      </div>

      <UserSearchBox />

      <AlertsCard alertType="alert" />

      {/* In flow on mobile — floating it there overlaps the content it sits on top of */}
      <span className="self-end text-xs text-muted-foreground md:fixed md:right-4 md:bottom-2">
        Version: {__APP_VERSION__} ({__BUILD_ID__})
      </span>
    </div>
  );
};
HomePage.displayName = 'HomePage';

export default HomePage;
